export const translations = {
  centro: {
    pt: "Centro",
    en: "Center",
    de: "Center",
    es: "Centrar",
  },
  obrigatorio: {
    pt: "Obrigtório",
    en: "Mandatory",
    de: "Verpflichtend",
    es: "Obligatorio",
  },
  adicionar: {
    pt: "Adicionar",
    en: "Add",
    de: "Addieren",
    es: "Agregar",
  },
  adicionando: {
    pt: "Adicionando...",
    en: "Adding...",
    de: "Wird hinzugefügt...",
    es: "Agregando...",
  },
  selecione: {
    pt: "Selecione...",
    en: "Select...",
    de: "Auswählen...",
    es: "Seleccione...",
  },

  centerExist: {
    pt: "Este centro já foi adicionado.",
    en: "This center has already been added.",
    de: "Dieses Zentrum wurde bereits hinzugefügt.",
    es: "Este centro ya ha sido agregado.",
  },
  centerMax: {
    pt: "Você só pode adicionar até 3 Centros.",
    en: "You can only add up to 3 centers.",
    de: "Sie können nur bis zu 3 Zentren hinzufügen.",
    es: "Solo puede agregar hasta 3 centros.",
  },
  profitExist: {
    pt: "Este centro de lucro já foi adicionado para este centro.",
    en: "This profit center has already been added for this center.",
    de: "Dieses Profitcenter wurde diesem Zentrum bereits hinzugefügt.",
    es: "Este centro de beneficio ya ha sido agregado a este centro.",
  },
  profitMax: {
    pt: "Você só pode adicionar até 3 Centros de lucro por Centro.",
    en: "You can only add up to 3 profit centers per center.",
    de: "Sie können nur bis zu 3 Profitcenter pro Zentrum hinzufügen.",
    es: "Solo puede agregar hasta 3 centros de beneficio por centro.",
  },
  adicionarCentro: {
    pt: "Adicionar Centro de lucro",
    en: "Add Profit Center",
    de: "Profitcenter hinzufügen",
    es: "Agregar centro de beneficio",
  },
  centroAssociado: {
    pt: "Centro de Lucro Associado",
    en: "Associated Profit Center",
    de: "Zugehöriges Profitcenter",
    es: "Centro de beneficio asociado",
  },
  centrosDeLucro: {
    pt: "Centros de Lucro",
    en: "Profit Centers",
    de: "Profitcenter",
    es: "Centros de beneficio",
  },
  centros: {
    pt: "Centros",
    en: "Centers",
    de: "Zentren",
    es: "Centros",
  },
  selecioneUmCentro: {
    pt: "Selecione um Centro",
    en: "Select a Center",
    de: "Wählen Sie ein Zentrum aus",
    es: "Seleccione un centro",
  },
  gerenciarCentrosDeLucro: {
    pt: "Gerenciar Centros / Centros de Lucro",
    en: "Manage Centers / Profit Centers",
    de: "Zentren / Profitcenter verwalten",
    es: "Gestionar centros / centros de beneficio",
  },
  nenhumCentroSelecionado: {
    pt: "Nenhum centro selecionado",
    en: "No center selected",
    de: "Kein Zentrum ausgewählt",
    es: "Ningún centro seleccionado",
  },
  confirmDeleteCenter: {
    pt: "Você tem certeza que deseja excluir este centro?",
    en: "Are you sure you want to delete this center?",
    de: "Sind Sie sicher, dass Sie dieses Zentrum löschen möchten?",
    es: "¿Está seguro de que desea eliminar este centro?",
  },
  deleteCenterWarning: {
    pt: 'Esta ação é irreversível. Clique em "Deletar" para confirmar ou "Cancelar" para voltar.',
    en: 'This action is irreversible. Click "Delete" to confirm or "Cancel" to go back.',
    de: "Diese Aktion ist unumkehrbar. Klicken Sie auf „Löschen“, um zu bestätigen, oder auf „Abbrechen“, um zurückzukehren.",
    es: 'Esta acción es irreversible. Haga clic en "Eliminar" para confirmar o en "Cancelar" para volver.',
  },
  deleteCenter: {
    pt: "Excluir centro",
    en: "Delete center",
    de: "Zentrum löschen",
    es: "Eliminar centro",
  },
  centerDeleted: {
    pt: "Centro excluído com sucesso.",
    en: "Center successfully deleted.",
    de: "Zentrum erfolgreich gelöscht.",
    es: "Centro eliminado con éxito.",
  },
  deleteError: {
    pt: "Erro ao excluir o centro.",
    en: "Error deleting the center.",
    de: "Fehler beim Löschen des Zentrums.",
    es: "Error al eliminar el centro.",
  },
  deleting: {
    pt: "Excluindo...",
    en: "Deleting...",
    de: "Wird gelöscht...",
    es: "Eliminando...",
  },
  cancelar: {
    pt: "Cancelar",
    en: "Cancel",
    de: "Abbrechen",
    es: "Cancelar",
  },
};
